export default type => [0, 2].includes(parseInt(type, 10))
